import {
  Box,
  Button,
  Tbody,
  Td,
  Text,
  Tooltip,
  Tr,
  Table as ChakraTable,
  useDisclosure,
  Flex,
  VStack,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { getHostDomain, getTagsData } from "../../utils/utils";
import { fetchController } from "../../utils/FetchController/fetchController";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import DeploymentModal from "../Modals/DeploymentModal";
import Table from "../Tables/Table";
import { providers } from "../Widgets/utils";
import TagsColumn from "../Tags/TagsColumn";
import Loader from "../../utils/Loader/Loader";

const NewDeployemnt = ({ assistantData = [] }) => {
  const agency = useContext(AgencyContext);
  const { buttonColorScheme } = agency;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const baseUrl = getHostDomain();
  const [widgetDataLength, setWidgetDataLength] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [heads, setHeads] = useState([]);
  const [tableStatus, setTableStatus] = useState("idle");

  const agencyLogoUrl = agency?.myDetails?.agency_id
    ? agency?.myDetails?.branding?.logo_url
    : null;
  const makeAgencyLogourl = (logo_url) => {
    if (!logo_url) return;
    return logo_url.includes(window.origin)
      ? logo_url
      : `${window.location.origin}${logo_url}`;
  };
  const logo = agency?.myDetails?.agency_id
    ? makeAgencyLogourl(agencyLogoUrl)
    : "/logo/favicon.png";
  const name = agency?.myDetails?.agency_id
    ? agency?.myDetails?.branding?.agency_name
    : "Insighto.AI";

  const getWidgetConnectedToAssistant = async () => {
    try {
      const assistantEndpoint = `/api/v1/assistant/${assistantData?.id}/widgets`;
      setTableStatus("loading");
      const urlHit = baseUrl + assistantEndpoint;
      const getData = await fetchController(urlHit, "GET");

      setWidgetDataLength(getData?.data?.total);
      const updatedData = getData.data.items.map((item) => {
        const providerData = providers[item?.widget_type];
        const provider = {
          label: providerData?.label || name,
          icon: <img src={providerData?.logo || logo} alt="logo" width={25} />,
        };
        const tagsData = getTagsData(item?.tags);

        return {
          widget_name: item.name,
          name: (
            <Box>
              <Text>{item.name}</Text>
              {item?.provider_user_friendly_label && (
                <Text fontSize={"xs"} fontStyle={"italic"}>
                  {item?.provider_user_friendly_label}
                </Text>
              )}
            </Box>
          ),
          description: item.description,
          widget_type: item.widget_type,
          id: item.id,
          provider: (
            <Tooltip label={provider.label}>
              <Box ml={4}>{provider.icon}</Box>
            </Tooltip>
          ),
          Tags: (
            <TagsColumn
              tagsData={tagsData}
              refreshTable={getWidgetConnectedToAssistant}
            />
          ),
        };
      });
      const columns = ["provider", "name", "Tags"].map((key) => ({
        Header: key,
        accessor: key,
        Filter: ({ column }) => <input {...column.filterProps} />,
      }));
      setTableData(updatedData);
      setHeads(columns);
      setTableStatus("success");
    } catch (error) {
      setTableStatus("failure");
    }
  };

  useEffect(() => {
    if (assistantData?.id) {
      getWidgetConnectedToAssistant();
    }
  }, [assistantData?.id]);

  return (
    <div>
      <DeploymentModal
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        assistantData={assistantData}
        fetch={getWidgetConnectedToAssistant}
        agencyLogo={agencyLogoUrl ? logo : null}
        agencyName={name}
      />
      <Flex justifyContent="flex-end">
        {widgetDataLength > 0 && (
          <Button size="sm" colorScheme={buttonColorScheme} onClick={onOpen}>
            New Deployment
          </Button>
        )}
      </Flex>
      {tableStatus !== "loading" ? (
        widgetDataLength > 0 ? (
          <Table
            fetch={getWidgetConnectedToAssistant}
            columns={heads}
            data={tableData}
            table="widget"
          />
        ) : (
          <ChakraTable variant="simple">
            <Tbody>
              <Tr>
                <Td colSpan={5} textAlign="center" py={10}>
                  <VStack>
                    <Text fontSize="lg" color="gray.500">
                      Create your first deployment now!
                    </Text>
                    <Button
                      size="sm"
                      colorScheme={buttonColorScheme}
                      onClick={onOpen}
                    >
                      Deploy Now
                    </Button>
                  </VStack>
                </Td>
              </Tr>
            </Tbody>
          </ChakraTable>
        )
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default NewDeployemnt;
